import React from "react";
import { Animation } from "../../assets/global/globalStyles";
import { fetchVehicles } from "../../store/vehicles";
import MetaTitle from "../../components/MetaTitle";
import useFetch from "../../hooks/useFetch";
import Table from "../../components/Table";
import USER_GROUPS from "../../global/variables/userGroups";

export default function Vehicles() {
  const { data: vehicles } = useFetch(
    fetchVehicles({
      url: "/vehicle",
      method: "GET",
    }),
    "vehicles",
    [USER_GROUPS.DHL]
  );

  return (
    <>
      <MetaTitle title="Veículos" />
      <Animation>
        <Table
          data={vehicles}
          title="Gerenciamento de Veículos"
          keyStorage="vehicles_filter"
          columns={["licensePlate", "category", "moduleType"]}
          columnNames={["Placa do veículo", "Categoria", "Tipo do módulo"]}
        />
      </Animation>
    </>
  );
}
